import React, { useMemo } from 'react';
import { orderBy } from 'lodash';
import { MultiStepFormSteps } from 'src/lib/MultiStepForm/types';
import { ICheckoutAll } from '../initialValues';
import { DeliveryInfoView, PaymentMethodView, PersonalInfoView } from '../components/AccordionInfo';
import { deliveryType } from '../../../../app/models/DeliveryType';

interface IInfoCard {
  title: string;
  id: number | string;
  render: JSX.Element;
  complete: boolean;
}

export const useInfoCards = (data: ICheckoutAll, completedSteps: Set<number | string>, steps: MultiStepFormSteps[]): IInfoCard[] => {
  const stepMap = useMemo(() => {
    const map: Record<string, number | string> = {};
    steps.forEach((s) => {
      map[s.title] = s.id;
    });
    return map;
  }, [steps]);

  return useMemo<IInfoCard[]>(() => {
    const renders: IInfoCard[] = [
      {
        title: 'Datos del comprador',
        id: stepMap['Datos del comprador'],
        render: <PersonalInfoView personalInfo={data.personalInfo} isResponsable={data.isResponsable} responsable={data.responsableInscripto} />,
        complete: completedSteps.has(stepMap['Datos del comprador']),
      },
      {
        title: deliveryType[data.delivered],
        id: stepMap['Información de envío'],
        render: <DeliveryInfoView data={data.deliveryInfo} isStorePickup={data.delivered === 'store_pickup'} />,
        complete: completedSteps.has(stepMap['Información de envío']),
      },
      {
        title: 'Medio de pago',
        id: stepMap['Medio de pago'],
        render: <PaymentMethodView paymentInfo={data.paymentMethod} cardInfo={data.cardInfo} couponData={data.coupon} />,
        complete: completedSteps.has(stepMap['Medio de pago']),
      },
    ];

    return orderBy(renders, 'id', 'asc');
  }, [data, completedSteps, stepMap]);
};
